var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 38,
    viewBox: "0 0 146 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7648_160644)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7648_160644)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32.2254,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32.2254,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_7648_160644)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1128 4.03882C11.348 4.03882 5.05331 10.2894 5.05331 18C5.05331 25.7105 11.348 31.9612 19.1128 31.9612C26.8776 31.9612 33.1723 25.7105 33.1723 18C33.1723 10.2894 26.8776 4.03882 19.1128 4.03882ZM4.9751 18C4.9751 10.2466 11.3048 3.96115 19.1128 3.96115C26.9208 3.96115 33.2505 10.2466 33.2505 18C33.2505 25.7534 26.9208 32.0388 19.1128 32.0388C11.3048 32.0388 4.9751 25.7534 4.9751 18Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1126 14.0779C16.9311 14.0779 15.1627 15.834 15.1627 18.0002C15.1627 20.1665 16.9311 21.9225 19.1126 21.9225C21.2941 21.9225 23.0626 20.1665 23.0626 18.0002C23.0626 15.834 21.2941 14.0779 19.1126 14.0779ZM15.0845 18.0002C15.0845 15.7911 16.8879 14.0002 19.1126 14.0002C21.3373 14.0002 23.1408 15.7911 23.1408 18.0002C23.1408 20.2094 21.3373 22.0002 19.1126 22.0002C16.8879 22.0002 15.0845 20.2094 15.0845 18.0002Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1126 15.3201C17.6223 15.3201 16.4142 16.5198 16.4142 17.9997C16.4142 19.4796 17.6223 20.6793 19.1126 20.6793C20.603 20.6793 21.8111 19.4796 21.8111 17.9997C21.8111 16.5198 20.603 15.3201 19.1126 15.3201ZM16.3359 17.9997C16.3359 16.4769 17.5791 15.2424 19.1126 15.2424C20.6462 15.2424 21.8893 16.4769 21.8893 17.9997C21.8893 19.5225 20.6462 20.757 19.1126 20.757C17.5791 20.757 16.3359 19.5225 16.3359 17.9997Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0735 2H19.1517V34H19.0735V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2253 17.9609L35.2253 18.0386L2.99999 18.0386L2.99999 17.9609L35.2253 17.9609Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7893 2H29.8675V34H29.7893V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7158 2H13.794V34H13.7158V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4314 2H24.5096V34H24.4314V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35791 2H8.43613V34H8.35791V2Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2253 28.6016L35.2253 28.6792L2.99999 28.6792L2.99999 28.6016L35.2253 28.6016Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2253 12.6406L35.2253 12.7183L2.99999 12.7183L2.99999 12.6406L35.2253 12.6406Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2253 23.2812L35.2253 23.3589L2.99999 23.3589L2.99999 23.2812L35.2253 23.2812Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2253 7.32031L35.2253 7.39798L2.99999 7.39798L2.99999 7.32031L35.2253 7.32031Z",
    fill: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_7648_160644)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.1127,
    cy: 18,
    rx: 8.05634,
    ry: 8,
    fill: "url(#paint1_linear_7648_160644)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_7648_160644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18H35.2254V21.2C35.2254 25.6804 35.2254 27.9206 34.3534 29.6319C33.5864 31.1372 32.3626 32.3611 30.8573 33.1281C29.146 34 26.9058 34 22.4254 34H15.8C11.3196 34 9.07937 34 7.36808 33.1281C5.86278 32.3611 4.63893 31.1372 3.87195 29.6319C3 27.9206 3 25.6804 3 21.2V18Z",
    fill: "white",
    fillOpacity: 0.2
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.7152 10.4535V19.8427C54.7152 21.8171 53.342 23.2376 51.1105 23.2376C48.8861 23.2376 47.5057 21.8171 47.5057 19.8427V10.4535H45.2957V20.0202C45.2957 23.0742 47.5987 25.2404 51.1105 25.2404C54.6222 25.2404 56.9324 23.0742 56.9324 20.0202V10.4535H54.7152Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1125 18.5217C62.1125 16.7816 63.1853 15.7873 64.673 15.7873C66.1249 15.7873 67.0046 16.7319 67.0046 18.3157V24.9989H69.1432V18.06C69.1432 15.3612 67.6483 13.9478 65.4025 13.9478C63.7503 13.9478 62.6704 14.7077 62.1625 15.8654H62.0266V14.0898H59.9739V24.9989H62.1125V18.5217Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1394 14.0898H74.8865V11.4762H72.7479V14.0898H71.1387V15.7944H72.7479V22.2362C72.7408 24.2177 74.2642 25.1765 75.9522 25.141C76.6316 25.1339 77.0894 25.006 77.3397 24.9137L76.9535 23.1594C76.8104 23.1879 76.5458 23.2518 76.2025 23.2518C75.5087 23.2518 74.8865 23.0245 74.8865 21.7958V15.7944H77.1394V14.0898Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5051 24.9989H81.6436V14.0898H79.5051V24.9989ZM80.585 12.4066C81.3217 12.4066 81.9368 11.8384 81.9368 11.1424C81.9368 10.4464 81.3217 9.87109 80.585 9.87109C79.8412 9.87109 79.2333 10.4464 79.2333 11.1424C79.2333 11.8384 79.8412 12.4066 80.585 12.4066Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6488 14.0898H87.3958V11.4762H85.2573V14.0898H83.648V15.7944H85.2573V22.2362C85.2501 24.2177 86.7736 25.1765 88.4615 25.141C89.141 25.1339 89.5987 25.006 89.8491 24.9137L89.4628 23.1594C89.3198 23.1879 89.0551 23.2518 88.7118 23.2518C88.0181 23.2518 87.3958 23.0245 87.3958 21.7958V15.7944H89.6488V14.0898Z",
    fill: "#101828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.389 10.4535H92.2504V24.9989H94.389V10.4535Z",
    fill: "#101828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.001 25.2191C104.397 25.2191 106.092 24.0472 106.578 22.2717L104.554 21.9094C104.168 22.9393 103.238 23.4648 102.022 23.4648C100.191 23.4648 98.9611 22.2859 98.9039 20.1836H106.714V19.4308C106.714 15.489 104.34 13.9478 101.851 13.9478C98.7894 13.9478 96.7725 16.2631 96.7725 19.6154C96.7725 23.0032 98.7608 25.2191 102.001 25.2191ZM98.911 18.5927C98.9968 17.0444 100.127 15.7021 101.865 15.7021C103.524 15.7021 104.611 16.9237 104.619 18.5927H98.911Z",
    fill: "#101828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.199 25.212C115.202 25.212 115.989 23.9975 116.375 23.3015H116.554V24.9989H118.642V10.4535H116.504V15.8583H116.375C115.989 15.1836 115.259 13.9478 113.214 13.9478C110.56 13.9478 108.608 16.0288 108.608 19.5657C108.608 23.0955 110.532 25.212 113.199 25.212ZM113.672 23.4009C111.762 23.4009 110.768 21.7319 110.768 19.5444C110.768 17.3782 111.74 15.7518 113.672 15.7518C115.538 15.7518 116.54 17.2646 116.54 19.5444C116.54 21.8384 115.517 23.4009 113.672 23.4009Z",
    fill: "#101828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.616 10.4535V19.8427C136.616 21.8171 135.243 23.2376 133.011 23.2376C130.787 23.2376 129.407 21.8171 129.407 19.8427V10.4535H127.197V20.0202C127.197 23.0742 129.5 25.2404 133.011 25.2404C136.523 25.2404 138.833 23.0742 138.833 20.0202V10.4535H136.616Z",
    fill: "#101828"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.257 10.4535H142.046V24.9989H144.257V10.4535Z",
    fill: "#101828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7648_160644",
    x: 0,
    y: 0,
    width: 38.2253,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7648_160644"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7648_160644",
    result: "effect2_dropShadow_7648_160644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7648_160644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_7648_160644",
    x: 8.0564,
    y: 8,
    width: 22.1128,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7648_160644"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7648_160644",
    result: "effect2_dropShadow_7648_160644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7648_160644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_7648_160644",
    x: -2,
    y: 13,
    width: 42.2253,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_7648_160644"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_7648_160644",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7648_160644",
    x1: 19.1127,
    y1: 2,
    x2: 19.1127,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D5DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7648_160644",
    x1: 15.0846,
    y1: 26,
    x2: 23.0508,
    y2: 9.95528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53389E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6941C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7648_160644"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 32.2254,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logoText.645388fb.svg";
export { ForwardRef as ReactComponent };